import { type PropsWithChildren, type ReactNode } from 'react';

import {
  type AriaLabelingProps,
  type DOMProps,
} from '@dynatrace/strato-components/core';

import { Group } from './components/Group.js';
import { Intent } from './components/Intent.js';
import { Item } from './components/Item.js';
import { ItemIcon } from './components/ItemIcon.js';
import { ItemTooltip } from './components/ItemTooltip.js';
import { Label } from './components/Label.js';
import { Link } from './components/Link.js';
import { Sub } from './components/Sub.js';
import { SubContent } from './components/SubContent.js';
import { SubTrigger } from './components/SubTrigger.js';

/**
 * @public
 */
export type ChartSeriesActionProps = DOMProps &
  AriaLabelingProps & {
    children: ReactNode;
    /**
     * Disabled
     * @defaultValue false
     */
    disabled?: boolean;
  };

/**
 * ChartSeriesAction component
 */
const ChartSeriesActionRoot = ({
  children,
}: PropsWithChildren<ChartSeriesActionProps>) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

ChartSeriesActionRoot['displayName'] = 'ChartSeriesAction';

/**
 * Slot component for chart series actions
 * @public
 */
export const ChartSeriesAction = Object.assign(ChartSeriesActionRoot, {
  Intent,
  Item,
  ItemTooltip,
  Label,
  ItemIcon,
  Group,
  Sub,
  SubTrigger,
  SubContent,
  Link,
});
